import { useLabelPrinting } from "@/hooks/useLabelPrinting";
import { useLang } from "@/context/LanguageContext";
import { discrepancyFlags } from "@/lib/boxing";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import BoxingSummary from "./BoxingSummary";
import StoreSection from "./StoreSection";

// The box-preparation screen body: progress and one section per store (boxes, plan, marketplace label files).
export default function BoxingBoard({ workStatus, stores, boxes, discrepancies, editable, canPrint, onAddBox, onOpenBox, onDeleteBox, onMessage, onChanged }) {
  const { t } = useLang();
  const labels = useLabelPrinting({ workStatus, boxes, onChanged, onMessage });
  const flags = discrepancyFlags(discrepancies);

  return (
    <div className="space-y-6">
      <BoxingSummary stores={stores} boxes={boxes} labelMode={labels.mode} />
      {stores.map(store => (
        <StoreSection key={store.store_id} store={store} boxes={boxes.filter(b => b.store_id === store.store_id)}
          flags={flags} editable={editable} canPrint={canPrint} labels={labels} onAddBox={onAddBox} onOpenBox={onOpenBox}
          onDeleteBox={onDeleteBox} onMessage={onMessage} />
      ))}
      <AlertDialog open={!!labels.confirmFile} onOpenChange={open => { if (!open) labels.cancelConfirm(); }}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("labels.complete_title")}</AlertDialogTitle>
            <AlertDialogDescription>{t("labels.complete_body")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
            <AlertDialogAction onClick={labels.confirmApplied} data-testid="confirm-complete-labels">{t("labels.complete_confirm")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
